export var facebookURL = 'http://www.facebook.com/notonthehighstreet/';
export var twitterURL = 'http://twitter.com/notonthehighst/';
export var pinterestURL = 'http://pinterest.com/notonthehighst/';
export var instagramURL = 'http://instagram.com/notonthehighstreet/';